import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import FooterSection from "../components/sections/FooterSection";
import "./PrivacyPage.css";

const PrivacyPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="privacy_page">
      <header className="privacy_page_header">
        <Link
          to="/"
          className="privacy_logo_link"
          onClick={() => window.scrollTo(0, 0)}
        >
          <span className="privacy_logo_insta">Insta</span>
          <span className="privacy_logo_snap">Snap</span>
        </Link>
      </header>
      <div className="privacy_page_content">
        <h1 className="privacy_page_title">Privacy Policy</h1>
        <p className="privacy_page_intro">
          Your privacy is very important to us. InstaSnap PhotoBooth is
          designed to ensure your photos remain completely private and secure.
        </p>
        <ul className="privacy_page_list">
          <li>All images are automatically and permanently deleted from the system immediately after printing.</li>
          <li>We do not store, access, or share any of your photos.</li>
          <li>Use InstaSnap with confidence—your memories stay yours.</li>
        </ul>
      </div>
      <FooterSection />
    </div>
  );
};

export default PrivacyPage;
